export const FIGMA_DEMO_LINK =
  "https://www.figma.com/file/OEmjKyp62DPePMl9yIDuR5/Figma-React-UI-kit-Preview";
export const BUY_LINK = "https://gum.co/figma2react";
export const SETPRODUCT_LINK = "https://setproduct.com/system";
export const LICENSE_LINK = "https://setproduct.com/license";
export const REACT_DOCS_LINK = "https://react.setproduct.com/";
